import { ActionReducer } from "@ngrx/store";

export function clearStateMetaReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return function(state, action) {
    // check for logout action type
    if (action.type === '[Auth] Logout') {
      state = undefined; // resets all slices to initial state
    }
    return reducer(state, action);
  };
}